<template>
  <v-app id="app" light>
    <Header/>
              <button
            id="qsLoginBtn"
            class="btn btn-primary btn-margin"
            v-if="!authenticated"
            @click="login()">
              Log In
          </button>

          <button
            id="qsLogoutBtn"
            class="btn btn-primary btn-margin"
            v-if="authenticated"
            @click="logout()">
              Log Out
          </button>

    <router-view
        :auth="auth" 
        :authenticated="authenticated"
    >
    </router-view>
  </v-app>
</template>

<script>
import Profile from './components/Profile.vue'
import Leaderboard from './components/Leaderboard.vue'
import Header from './components/Header.vue'
import AuthService from './auth/AuthService'
/* eslint-disable */

const auth = new AuthService()
const { login, logout, authenticated, authNotifier } = auth

export default {
  name: 'app',
  components: {
    Leaderboard,
    Header,
    Profile
  },
  data () {
    authNotifier.on('authChange', authState => {
      this.authenticated = authState.authenticated
    })
    return {
      auth,
      authenticated
    }
  },
  methods: {
    login,
    logout
  }
}
</script>

<style>
html {
  height: 100%;
  overflow: hidden !important;
}
body::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-image: url("./assets/handshake.jpg");
  height: 100%; 
  z-index: -1;
  opacity: .7;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
#app {
  height: 100vh;
  overflow-y: auto;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: unset;
}
#app .v-table, #app .v-datatable, #app .v-datatable__actions {
  background: none;
}
.application--wrap {
  display: block !important;
}
</style>
